/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * What `POST /transactions/{id}/undo` would do, for the confirm dialog.
 * @export
 * @interface UndoPreviewResponse
 */
export interface UndoPreviewResponse {
    /**
     * 
     * @type {string}
     * @memberof UndoPreviewResponse
     */
    fromStatus: string;
    /**
     * 
     * @type {string}
     * @memberof UndoPreviewResponse
     */
    toStatus: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UndoPreviewResponse
     */
    irreversible: Array<string>;
}

/**
 * Check if a given object implements the UndoPreviewResponse interface.
 */
export function instanceOfUndoPreviewResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fromStatus" in value;
    isInstance = isInstance && "toStatus" in value;
    isInstance = isInstance && "irreversible" in value;

    return isInstance;
}

export function UndoPreviewResponseFromJSON(json: any): UndoPreviewResponse {
    return UndoPreviewResponseFromJSONTyped(json, false);
}

export function UndoPreviewResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UndoPreviewResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fromStatus': json['from_status'],
        'toStatus': json['to_status'],
        'irreversible': json['irreversible'],
    };
}

export function UndoPreviewResponseToJSON(value?: UndoPreviewResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'from_status': value.fromStatus,
        'to_status': value.toStatus,
        'irreversible': value.irreversible,
    };
}

